/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ACESFund.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_CHECKFUND_EXHAUSTED = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESFUND/FETCH_CHECKFUND_EXHAUSTED`
);

export { FETCH_CHECKFUND_EXHAUSTED };
